const yup = require("yup");

const create = yup.object({
  programme: yup.string().required("Programme is required"),
  label: yup.string().required("Label is required"),
  status: yup.boolean().required("Status is a required fields"),
  indigene: yup.number().required("Indigene is a required fields"),
  amount: yup.number().required("Amount is a required fields"),
});

module.exports = {
  create,
};
